import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonIcon } from "@ionic/react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { AsyncMaterialsAutocomplete } from "../../../components";
import { ToolfinderMaterialForm } from "./FormTypes";
import { arrowDownOutline, createOutline } from "ionicons/icons";
import { useState } from "react";
import { getMaterialLabel } from "../../calculator/components/formHelpers";
import { useTranslation } from "react-i18next";

interface MaterialFormProps {
    submitForm: (data: any) => void,
    editBtnCallback: () => void
    isFormShowing: boolean,
}

const defaultFormValues = {
    material: null,
}

const MaterialForm: React.FC<MaterialFormProps> = ({ submitForm, editBtnCallback, isFormShowing }: MaterialFormProps) => {
    const { control, handleSubmit, formState: { errors } } = useForm<ToolfinderMaterialForm>({
        mode: "onTouched",
        reValidateMode: "onChange",
        defaultValues: defaultFormValues
    });
    const [data, setData] = useState<ToolfinderMaterialForm | undefined>()
    const { t } = useTranslation();

    const onSubmit: SubmitHandler<ToolfinderMaterialForm> = data => {
        setData(data)
        submitForm(data)
    }

    if (isFormShowing) {
        return (
            <>
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle>{t("toolfinder.materialForm.material")}</IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>
                        <form>
                            <div style={{ width: "100%" }}>
                                <Controller
                                    render={({ field: { onChange, onBlur, value } }) => (
                                        <AsyncMaterialsAutocomplete
                                            onChange={onChange}
                                            onBlur={onBlur}
                                            value={value}
                                            disabled={false}
                                        />
                                    )}
                                    control={control}
                                    name="material"
                                    defaultValue={null}
                                    rules={{
                                        required: { value: true, message: t("Feld darf nicht leer sein") },
                                    }}
                                />
                                {/* @ts-ignore */}
                                {errors.material && <div style={{ textAlign: "left", color: "#eb445a", fontSize: 14 }}>{errors.material.message}</div>}
                            </div>
                            <IonButton style={{ marginTop: 24 }} onClick={handleSubmit(onSubmit)} expand="block"><IonIcon slot="start" icon={arrowDownOutline} />{t("toolfinder.materialForm.bearbeitung")}</IonButton>
                        </form>
                    </IonCardContent>
                </IonCard>
            </>
        )
    } else {
        if (data) {
            return (
                <IonCard color="light" className="millerFormCompletedCard">
                    <IonCardContent>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                            <div>
                                <div><b>{t("toolfinder.materialForm.material")}:</b> {getMaterialLabel(data.material!)}</div>
                            </div>
                            <div>
                                <IonButton fill="outline" onClick={editBtnCallback}>
                                    <IonIcon icon={createOutline} slot="icon-only" />
                                </IonButton>
                            </div>
                        </div>
                    </IonCardContent>
                </IonCard>
            )
        }
        return null
    }
}

export default MaterialForm;